// Auth API endpoints
import apiClient from './client';
import type {
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  User,
} from '@/types/models/user.types';
import type { ApiResponse } from '@/types/api/response.types';

export const authApi = {
  /**
   * Register a new user
   */
  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>(
      '/api/auth/register',
      data
    );
    return response.data.data!;
  },

  /**
   * Login with email and password
   */
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>(
      '/api/auth/login',
      data
    );
    return response.data.data!;
  },

  /**
   * Get current user
   */
  me: async (): Promise<User> => {
    const response = await apiClient.get<ApiResponse<User>>('/api/users/me');
    return response.data.data!;
  },

  /**
   * Update user profile
   */
  updateProfile: async (data: { name?: string; avatar_url?: string }): Promise<User> => {
    const response = await apiClient.patch<ApiResponse<User>>('/api/users/me', data);
    return response.data.data!;
  },
};
